/** Navigate back and reset the Sentry error boundary so the fallback UI is dismissed. */
export function goBackAndResetError(resetError: () => void): void {
    let didReset = false;
    const reset = () => {
        if (didReset) return;
        didReset = true;
        resetError();
    };

    window.addEventListener('popstate', reset, { once: true });
    window.history.back();
    // Fallback when popstate does not fire (e.g. no history entry or SPA edge cases)
    window.setTimeout(reset, 150);
}
